/**
 * @generated SignedSource<<02f1f7b1803963a7ce234c2e9ac53e84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageItemActions_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StorePackageModal_session">;
  readonly " $fragmentType": "PackageItemActions_session";
};
export type PackageItemActions_session$key = {
  readonly " $data"?: PackageItemActions_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageItemActions_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageItemActions_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorePackageModal_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "4074c6ce36cbf67e5ceced4975dc2e65";

export default node;
